import { createSlice } from '@reduxjs/toolkit'

const initState = {
    isCollapse: localStorage.getItem('isCollapse') === 'true' ? true : false
}

const isCollapseSlice = createSlice({
    name: 'isCollapse',
    initialState: initState,
    reducers: {
        // standard reducer logic, with auto-generated action types per reducer
        changeIsCollapse: (state, action) => {
            state.isCollapse = action.payload
            localStorage.setItem('isCollapse', action.payload)
        }
    },
})

export const { changeIsCollapse } = isCollapseSlice.actions

export default isCollapseSlice.reducer